import { useEffect, useRef, useState } from 'react'
import { LightboxImage } from './Lightbox'
import { Link } from 'wouter'

const RudySection = () => {
  const posterRef = useRef<HTMLDivElement>(null)
  const [inView, setInView] = useState(false)

  useEffect(() => {
    const el = posterRef.current
    if (!el) return
    const observer = new IntersectionObserver(
      ([entry]) => { if (entry.isIntersecting) { setInView(true); observer.disconnect() } },
      { threshold: 0.2 }
    )
    observer.observe(el)
    return () => observer.disconnect()
  }, [])

  return (
    <section className="relative w-full bg-black overflow-hidden">
      <div className="absolute inset-0 bg-gradient-to-b from-[#0a0f1a] via-black to-black"></div>

      <div className="relative z-10 max-w-5xl mx-auto px-6 md:px-12 pt-10 md:pt-16">
        <div className="text-center mb-16">
          <h2 className="text-3xl md:text-4xl lg:text-5xl font-black font-montserrat uppercase tracking-wide text-white leading-tight mb-4">
            "Your Odds Are 40–50%."
          </h2>
          <p className="text-yellow-400 text-xl md:text-2xl font-poppins font-light italic">
            His answer: "Tell me where the road starts."
          </p>
        </div>

        <div className="flex flex-col md:flex-row items-center gap-8 md:gap-12 mb-16">
          {/* Poster — left, flies in from left */}
          <div ref={posterRef} className="md:w-1/2 order-1 md:order-1 flex justify-center">
            <div className={`w-[90%] md:w-[45%] lg:w-[65%] rounded-lg overflow-hidden transition-all duration-700 ease-out ${inView ? 'opacity-100 translate-x-0' : 'opacity-0 -translate-x-20'}`}>
              <LightboxImage
                src="/spoke-static/images/spoke-rudy-poster.jpg"
                alt="SPOKE official film poster — Rudy Pospisil raising a bicycle overhead in firefighter gear"
                className="w-full rounded-lg object-contain"
              />
            </div>
          </div>
          {/* Text — right */}
          <div className="md:w-1/2 flex flex-col order-2 md:order-2">
            <p className="text-white text-base md:text-lg xl:text-xl leading-relaxed font-poppins font-light px-2 md:px-0 mb-4">
              When an oncologist tells firefighter Rudy Pospisil his chances of beating cancer, he doesn't book a cruise; he gets on a bike and points it from Canada to Mexico.
            </p>
            <p className="text-white text-base md:text-lg xl:text-xl leading-relaxed font-poppins font-light px-2 md:px-0">
              And then just keeps going, through hurricanes, headwinds, typhoons, and the steepest street in New Zealand. With one purpose: To raise funds and awareness for occupational cancer in the firefighting community.
            </p>
          </div>
        </div>

        <div className="grid grid-cols-2 gap-2 md:gap-3 max-w-5xl mx-auto mb-10 md:mb-16">
          <div className="overflow-hidden rounded-lg">
            <LightboxImage
              src="/spoke-static/images/SPOKE_Rudy_Pospisil_Firefighter_Canada_Rookie.jpg"
              alt="SPOKE film Rudy Pospisil as a rookie firefighter with the Vancouver Fire Department team"
              className="w-full h-full object-cover aspect-[4/3]"
            />
          </div>
          <div className="overflow-hidden rounded-lg">
            <LightboxImage
              src="/spoke-static/images/SPOKE_Rudy_cycling_steep_street.jpg"
              alt="SPOKE film Rudy Pospisil cycling up steep street in New Zealand"
              className="w-full h-full object-cover aspect-[4/3]"
            />
          </div>
          <div className="overflow-hidden rounded-lg">
            <LightboxImage
              src="/spoke-static/images/SPOKE_Rudy_cycling_celebration.jpg"
              alt="SPOKE film Rudy Pospisil celebrating with firefighters and supporters holding flags and trophy"
              className="w-full h-full object-cover aspect-[4/3]"
            />
          </div>
          <div className="overflow-hidden rounded-lg">
            <LightboxImage
              src="/spoke-static/images/SPOKE_Rudy_firefighter_kids.jpg"
              alt="SPOKE film Rudy Pospisil in firefighter gear kneeling with three kids in colorful studio"
              className="w-full h-full object-cover aspect-[4/3]"
            />
          </div>
        </div>

        <div className="flex justify-center mb-10 md:mb-16">
          <Link
            href="/dosomething"
            className="inline-block bg-yellow-400 hover:bg-yellow-300 text-black font-montserrat font-black uppercase tracking-widest text-base px-10 py-4 transition-colors duration-300"
          >
            DO SOMETHING
          </Link>
        </div>

        <div className="flex items-center justify-center gap-1 pb-10 md:pb-16">
          <div className="w-[45%] h-[2px] bg-red-600"></div>
          <div className="w-[22%] h-[2px] bg-yellow-400"></div>
        </div>
      </div>
    </section>
  )
}

export default RudySection
